import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Heart } from "lucide-react";
import { MINISTRY } from "@/lib/content";
import DonateDialog from "./DonateDialog";

export default function Footer() {
  return (
    <footer className="relative z-10 bg-plum-dark text-cream/80" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-3 mb-5">
            <span className="grid place-items-center w-11 h-11 rounded-full bg-gold text-plum font-heading text-2xl font-semibold">G</span>
            <span className="font-heading text-xl text-cream">Greater Faith</span>
          </div>
          <p className="text-sm leading-relaxed text-cream/70">
            {MINISTRY.tagline} Serving Norfolk and beyond with mentorship, outreach, and hope in action.
          </p>
        </div>

        <div>
          <h4 className="font-heading text-lg text-gold mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            {[["/about", "About Us"], ["/programs", "Programs"], ["/blog", "Blog"], ["/testimonials", "Testimonials"], ["/get-involved", "Get Involved"], ["/contact", "Contact"]].map(([to, label]) => (
              <li key={to}>
                <Link to={to} className="hover:text-gold transition-colors" data-testid={`footer-${label.toLowerCase().replace(/\s/g, "-")}`}>{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-lg text-gold mb-4">Visit Us</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3"><MapPin size={18} className="text-gold shrink-0 mt-0.5" /><span>{MINISTRY.address}</span></li>
            <li className="flex gap-3"><Phone size={18} className="text-gold shrink-0 mt-0.5" /><a href={`tel:${MINISTRY.phone}`} className="hover:text-gold">{MINISTRY.phone}</a></li>
            <li className="flex gap-3"><Mail size={18} className="text-gold shrink-0 mt-0.5" /><a href={`mailto:${MINISTRY.email}`} className="hover:text-gold text-[13px] whitespace-nowrap">{MINISTRY.email}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-lg text-gold mb-4">Partner With Us</h4>
          <p className="text-sm text-cream/70 mb-4">Your gift restores homes, mentors youth, and feeds families.</p>
          <DonateDialog
            trigger={
              <button className="bg-gold hover:bg-gold-dark text-plum font-semibold rounded-full px-6 py-3 flex items-center gap-2 transition-colors" data-testid="footer-donate-btn">
                <Heart size={16} /> Give Today
              </button>
            }
          />
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/50">
          <p>&copy; {new Date().getFullYear()} Greater Faith International Ministries. All rights reserved.</p>
          <p>Under the covering of The New City Church of Virginia.</p>
        </div>
      </div>
    </footer>
  );
}
